import React from 'react';

import Section from "../../Section";
import TagGrid from "../../TagGrid";
import Tile from "../../Tile";

const skills = [
  "after_effects",
  "css3",
  "es6",
  "es7",
  "express",
  "git",
  "grunt",
  "handlebars",
  "illustrator",
  "linux",
  "live",
  "logic",
  "math",
  "mdl",
  "mongo_db",
  "mysql",
  "photoshop",
  "polymer",
  "postcss",
  "premiere",
  "react",
  "sass",
  "webcomp",
  "webpack"
]


export default function Skills(props) {
  return <Section>
    <a name="skills" />
    <h1 className="h3 mdl-typography--display-1-color-contrast">Skills</h1>
    <TagGrid source={skills} tag={Tile} path="/images/skills/" />;
  </Section>
}



// WEBPACK FOOTER //
// ./src/Pages/Skills/Skills.js